/** @format */

const BUSINESS_UNIT = {
  COCOA: "Cocoa",
  EDIBLE_OILS: "Edible Oils",
  GRAINS: "Grains",
  ANIMAL_FEED: "Animal Feed",
  CORN: "Corn",
};

export { BUSINESS_UNIT };
